import BasicResources from './basic-resources';

class Resources {
  static createResources(parentEnv) {
    const env = parentEnv || Resources.env;
    const BASE_URL_ASSESSMENTS_ASSIGN = window._env_.AssessmentAssignGateway;
    const BASE_URL_UPF_ASSIGN = window._env_.UpfAssignGateway;

    /* Filters */
    Resources.classrooms = env
      .resource('classrooms')
      .baseUrl(BASE_URL_ASSESSMENTS_ASSIGN)
      .service('classrooms');

    Resources.publications = env
      .resource('publicationcourses')
      .baseUrl(BASE_URL_ASSESSMENTS_ASSIGN)
      .service('assessments');

    Resources.genericCourses = env
      .resource('genericcourse')
      .baseUrl(BASE_URL_ASSESSMENTS_ASSIGN)
      .service('assessments/{id}/versions/{version}');

    Resources.studentassignments = env.resource('studentassignments')
      .baseUrl(BASE_URL_ASSESSMENTS_ASSIGN)
      .service('getAssignments');

    Resources.previewAssessment = env.resource('previewAssessment')
      .baseUrl(BASE_URL_ASSESSMENTS_ASSIGN)
      .service('previewAssessment');

    Resources.assign = env.resource('assign')
      .baseUrl(BASE_URL_ASSESSMENTS_ASSIGN)
      .service('assignAssessment');

    Resources.unassign = env.resource('unassign')
      .baseUrl(BASE_URL_ASSESSMENTS_ASSIGN)
      .service('assignments');

    Resources.previewUpf = env.resource('previewUpf')
      .baseUrl(BASE_URL_UPF_ASSIGN)
      .service('assign/preview');

    Resources.getLearningGaps = env.resource('getLearningGaps')
      .baseUrl(BASE_URL_ASSESSMENTS_ASSIGN)
      .service('getLearningGaps');

    Resources.getLearningGapsPerStudent = env.resource('getLearningGapsPerStudent')
      .baseUrl(BASE_URL_ASSESSMENTS_ASSIGN)
      .service('getLearningGapsPerStudent');

    Resources.assignLearningGaps = env.resource('assignLearningGaps')
      .baseUrl(BASE_URL_ASSESSMENTS_ASSIGN)
      .service('assignLearningGaps');

    Resources.assignLearningGapsPerStudent = env.resource('assignLearningGapsPerStudent')
      .baseUrl(BASE_URL_ASSESSMENTS_ASSIGN)
      .service('assignLearningGapsPerStudent');

    Resources.getSingleQuestion = env.resource('getSingleQuestion')
      .baseUrl(BASE_URL_ASSESSMENTS_ASSIGN)
      // eslint-disable-next-line max-len
      .service('preview-assessment-question/assessmentId/{id}/assessmentVersion/{version}/girlId/{girlId}/locale/{locale}');
  }
  static initialise(envName, credentials) {
    Resources.env = BasicResources.initialise(envName, credentials);

    Resources.createResources();

    return Resources.env;
  }
}

export default Resources;

